
import React from "react";
import { Breadcrumb } from "react-bootstrap";
import SmartAssistPhase1 from "./SmartAssistPhase1";
import SmartAssistPhase2 from "./SmartAssistPhase2";
import SmartAssistPhase3 from "./SmartAssistPhase3";
import { NAV_ITEMS } from "../helper";
import { useSmartAssistStore } from "../store";

const SmartAssistProbing = () => {
  const { currentSaPhase, setCurrentSaPhase, selectedIssue } = useSmartAssistStore();

  const NAVIGATION_ITEMS = {
    [NAV_ITEMS.HOME]: [NAV_ITEMS.HOME],
    [NAV_ITEMS.HOW_TO_USE]: [NAV_ITEMS.HOME, NAV_ITEMS.HOW_TO_USE],
    [NAV_ITEMS.SUMMARY]: [NAV_ITEMS.HOME, NAV_ITEMS.HOW_TO_USE, NAV_ITEMS.SUMMARY]
  };

  return (
    <div className="px-2">
      <Breadcrumb className="mb-2">
        {NAVIGATION_ITEMS[currentSaPhase]
          ?.filter(item =>
            currentSaPhase !== NAV_ITEMS.SUMMARY || selectedIssue.product_read || item !== NAV_ITEMS.HOW_TO_USE
          )
          .map((item, index) => (
            <Breadcrumb.Item
              onClick={() => setCurrentSaPhase(item)}
              key={index}
              active={index === NAVIGATION_ITEMS[currentSaPhase].length - 1}
            >
              {item}
            </Breadcrumb.Item>
          ))}
      </Breadcrumb>

      <div>
        {(() => {
          switch (currentSaPhase) {
            case NAV_ITEMS.HOME:
              return <SmartAssistPhase1 />;

            case NAV_ITEMS.HOW_TO_USE:
              return <SmartAssistPhase2 />;

            case NAV_ITEMS.SUMMARY:
              return <SmartAssistPhase3 />;

            default:
              return null;
          }
        })()}
      </div>
    </div>
  );
};

export default SmartAssistProbing;
